import React from "react";
import {SubmitButton} from "../../design";
//import {isApplePayJsAvailable, performApplePayPayment} from "./ApplePayJsHandler"
import {performValidation} from './ApplePayRestClient';
import currencyformatter from "../../utils/currencyformatter";
import { AmountDivideByHundred } from "../../helper";

type Props = {
    chargeByApple: Function;
};


const Apple = (props: Props) => {
    const {amount, chargeByApple, payment,accountName} = props;
    const items = []

    const existsApplePayJsApi = () => {
        return new Promise((resolve, reject) => {
            try {
                const enabled = window.ApplePaySession && window.ApplePaySession.canMakePayments();
                resolve(enabled);
            } catch (err) {
                reject(err);
            }
        })
    }

    const isApplePayJsAvailable = () => {
        try {
            return existsApplePayJsApi()
                .then(() => {
                    return window.ApplePaySession.canMakePaymentsWithActiveCard('merchant.com.swirepay.fiserv')
                })
        } catch (error) {
            console.error('Error checking Apple Pay availability:', error);
            return false;
        }
    }

    const getPaymentRequest = (currencyCode, items, label, amount) => {
        return {
            currencyCode: currencyCode,
            countryCode: 'US',
            lineItems: items,
            total: {
                label: label,
                amount: amount
            },
            supportedNetworks: ['masterCard', 'visa'],
            merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
            requiredShippingContactFields: [
                "postalAddress",
                "name",
                "phone",
                "email"
            ],
            requiredBillingContactFields: [
                "postalAddress",
                "email",
                "name",
                "phone"
            ]
        }
    }

    const getOnValidateMerchant = (resolve, reject, session, amount) => {
        return async (event) => {
            await performValidation(event.validationURL)
                .then((response) => {
                    console.log(response.body)
                    session.completeMerchantValidation(response.body);

                })
                .catch((err) => {
                    console.log("Validate error ", JSON.stringify(err));
                    session.abort();
                });
        }
    }

    const getOnPaymentAuthorized = (resolve, reject, session, currencyCode, amount) => {
        return (event) => {
            session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
            const payment = event.payment
            const devicedata = `${payment.token.paymentData.data}&ectype=apple&ecsig=${payment.token.paymentData.signature}&eckey=${payment.token.paymentData.header.ephemeralPublicKey}&ectid=${payment.token.transactionIdentifier}&echash=&ecpublickeyhash=${payment.token.paymentData.header.publicKeyHash}`;
            console.log(payment)
            const customerName = ((payment.billingContact.givenName)? payment.billingContact.givenName :"") + (payment.billingContact.familyName ?payment.billingContact.familyName:"" )
            const customerPhone = '+1' +payment.shippingContact.phoneNumber ? '+1' +payment.shippingContact.phoneNumber:""
            const customerEmail = payment.shippingContact.emailAddress ? payment.shippingContact.emailAddress:""
            const countryCode = payment.billingContact.countryCode ? payment.billingContact.countryCode:""
            const stateCode = payment.billingContact.administrativeArea ? payment.billingContact.administrativeArea:""
            const city = payment.billingContact.locality ? payment.billingContact.locality:""
            const street = payment.billingContact.addressLines[0]? payment.billingContact.addressLines[0]:""
            const postalCode = payment.billingContact.postalCode?payment.billingContact.postalCode:""
            const cardNetwork = payment.token.paymentMethod.network ? payment.token.paymentMethod.network:""
            const cardType = payment.token.paymentMethod.network ? payment.token.paymentMethod.network:""
            const cardLast4 = payment.token.paymentMethod.displayName ? payment.token.paymentMethod.displayName:""
           
            chargeByApple(devicedata, amount, customerName, customerEmail,
                customerPhone, countryCode, stateCode, street, postalCode, city,
                cardNetwork, cardType, cardLast4);
        }
    }

    const getOnCancel = (resolve, reject, session) => {
        return (event) => {
            console.log("Session cancelled!!!");
            resolve(2);
        }
    }

    const performApplePayPayment = (currencyCode, items, label, amount) => {
        // alert(currencyCode)
        return new Promise((resolve, reject) => {
            const session = new window.ApplePaySession(1, getPaymentRequest(currencyCode, items, label, amount));

            session.onvalidatemerchant = getOnValidateMerchant(resolve, reject, session, amount);
            session.onpaymentauthorized = getOnPaymentAuthorized(resolve, reject, session, currencyCode, amount);
            session.oncancel = getOnCancel(resolve, reject, session)

            session.begin();
        })
    }

    if (isApplePayJsAvailable()) {
        return (
            <>
                <SubmitButton type="secondary"
                              borderRadius="50px"
                              border="1px solid #40a9ff !important"
                              className="px-3 py-2 mt-3"
                              onClick={() => performApplePayPayment('USD', items, payment.account&&payment.account.name?payment.account.name:accountName, AmountDivideByHundred(amount))}

                >Pay By Apple Pay {currencyformatter(AmountDivideByHundred(amount),'USD')}</SubmitButton>
            </>
        )
    }
};


export default Apple;
